import React from "react";
import logo from "../../Assets/images/MSDLogo.png"

const Invoice = () => {
    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="text-center logoImage pt-5 col-sm-12">
                    <img src={logo} alt="logo" />
                </div>
            </div>
            <div className="row text-center">
                <div className="mb-4 mt-4 col-sm-12">
                    <label className="form_heading"> Invoice</label>
                </div>
            </div>
            <div className="mt-2 borderline pb-3 row xs-1 sm-2">
                <div className="col-sm-12 col-md-7">
                    <div className="form_header mb-3">From</div>
                    <div className="row ps-2">
                        <div className="col-sm-4"> <label>MSD Cars,</label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-4"> <label>Chrompet</label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-4"> <label>9790953700</label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-4"> <label>support@msdcars.in</label> </div>
                    </div>
                </div>
                <div className="col-md-5 col-sm-12">
                    <div className="form_header mb-3">To</div>
                    <div className="row ps-2">
                        <div className="col-sm-5"> <label> Booking ID </label> </div>
                        <div className="col-sm-4"> <label id="book_id"> </label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-5"> <label> Customer ID </label> </div>
                        <div className="col-sm-4"> <label id="cust_id">  </label> </div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-5"> <label> Name </label> </div>
                        <div className="col-sm-4"><label className="text-capitalize" id="cust_name">  </label></div>
                    </div>
                    <div className="row ps-2">
                        <div className="col-sm-5"> <label> Mobile </label> </div>
                        <div className="col-sm-4"><label id="mobile">   </label></div>
                    </div>
                </div>
            </div>
            <div className="mt-4 row xs-1 sm-3 justify-content-between">
                <div className="col-sm-12 col-md-4">
                    <div className="form_header mb-3">Delivery Data</div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Date</label> </div>
                        <div className="col-sm-4"> <label id="delivery_date">  </label> </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Time</label> </div>
                        <div className="col-sm-4"> <label id="delivery_time">   </label> </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Location</label> </div>
                        <div className="col-sm-4"> <label className="text-capitalize" id="delivery_location"> </label> </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4">
                    <div className="form_header mb-3">Pickup Data</div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Date</label> </div>
                        <div className="col-sm-4"> <label id="pickup_date">  </label> </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Time</label> </div>
                        <div className="col-sm-4"> <label id="pickup_time">   </label> </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4"> <label>Location</label> </div>
                        <div className="col-sm-4"> <label className="text-capitalize" id="pickup_location"> </label> </div>
                    </div>
                </div>
            </div>
            <div className="my-4 row">
                <div className="col">
                    <div className="overflow">
                        <table className="table table_invoice stripedTable">
                            <thead>
                                <tr>
                                    <th className="tableBackColor">Description </th>
                                    <th className="border_total tableBackColor">Price </th>
                                    <th className="text-center tableBackColor">Amount </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border_total">Cost per day</td>
                                    <td id="rent_per_day" className="border_total"></td>
                                    <td id="rent_per_day_total" className="text-center border_total"></td>
                                </tr>
                                <tr>
                                    <td className="border_total tableSubHeadingColor">Extra Charges</td>
                                    <td id="extra_charges" className="border_total tableSubHeadingColor"></td>
                                    <td id="extra_charge" className="text-center border_total tableSubHeadingColor"></td>
                                </tr>
                                <tr>
                                    <td className="border_total tableSubHeadingColor">Other Charges</td>
                                    <td id="other_charge" className="border_total tableSubHeadingColor"></td>
                                    <td id="other_charges" className="text-center border_total tableSubHeadingColor"></td>
                                </tr>
                                <tr>
                                    <td className="border_total tableSubHeadingColor">Offer Price</td>
                                    <td id="offer_charge" className="border_total tableSubHeadingColor"></td>
                                    <td id="offer_charges" className="text-center border_total tableSubHeadingColor"></td>
                                </tr>
                                <tr className="table_border">
                                    <td className="table_border"></td>
                                    <td className="text-center border-bottom border-left tableBackColor">Final Amount</td>
                                    <td className="text-center border-bottom border-right tableBackColor"><label id="final"></label></td>
                                </tr>
                                <tr className="table_border">
                                    <td className="table_border change-white"></td>
                                    <td className="text-center border-bottom border-left tableBackColor">GST </td>
                                    <td className="text-center border-bottom border-right tableBackColor"><label id="gst"></label> </td>
                                </tr>
                                <tr className="table_border">
                                    <td className="table_border"></td>
                                    <td className="text-center border-bottom border-left tableBackColor">Total Cost Collected </td>
                                    <td className="text-center border-bottom border-right tableBackColor"><label id="total_cost"></label></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Invoice;